// This file can be moved to a more appropriate location later on 
class EntitlementGroup{
    constructor(constructorObject){
        for(var key in constructorObject){
            this[key] = constructorObject[key];
        }

        this.defaultIdDescriptor = "entitlement_setting_id"; // for self
    }

    isFoundInServiceList(serviceList, serviceIdDescriptor = "entitlement_setting_id"){ // for service
        for (let i = 0; i < serviceList.length; i++) {
            const service = serviceList[i];
            if(this[this.defaultIdDescriptor] == service[serviceIdDescriptor]){ // TODO double check this logic
                return true;
            }
        }
        return false;
    }

}

module.exports = EntitlementGroup;